import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
class GetUnseenSavedSearchMatchesUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} config
   * @param {Service} deps.getUnseenSavedSearchMatchesService

   */
  constructor({config, getUnseenSavedSearchMatchesService}) {
    super()
    this._config = config
    this._getUnseenSavedSearchMatchesService = getUnseenSavedSearchMatchesService
  }

  /**
   * @return {Promise<Number>} number of unseen saved search matches
   */
  @inlineError
  async execute(alertId) {
    const notificationsVO = await this._getUnseenSavedSearchMatchesService.execute(alertId)

    return notificationsVO.toJSON().matchCounters
  }
}

export default GetUnseenSavedSearchMatchesUseCase
